import { About } from "pages/about/about";
import { Error } from "pages/error/error";
import { Logout } from "pages/logout/logout";
import { Landing } from "pages/landing/landing";
import { Profile } from "pages/profile/profile";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "routes/protected-route";
import { IBFRoutes } from "./IBFRoutes";
import { LEAPRoutes } from "./LEAPRoutes";
import { isIBFEnabled } from "utils/helpers";
import { Catalog } from "pages/catalog/catalog";
import { Course } from "pages/course/course";
import { Player } from "pages/player/player";

const AppRoutes = () => {
  return <>{isIBFEnabled() ? <IBFRoutes /> : <LEAPRoutes />}</>;
};

const routes = (
  <Routes>
    <Route path="/" element={<ProtectedRoute><Landing /></ProtectedRoute>} />
    <Route path="/about" element={<About />} />
    <Route path="/error" element={<Error />} />
    <Route path="/logout" element={<Logout />} />
    <Route path="/profile/:activeTabId?" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
    <Route path="/catalog/:category?" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
    <Route path="/course/:id" element={<ProtectedRoute><Course /></ProtectedRoute>} />
    <Route path="/player/:contentId/:activityId" element={<ProtectedRoute><Player /></ProtectedRoute>} />
    {/* AppRoutes nested routes */}
    <Route path="/*" element={<AppRoutes />} />
  </Routes>
);

export default routes;
